import React, { useState } from "react";
import { Container, TextField, Button, Typography, Box, Alert } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate(); // ナビゲーション用

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); 
    setSuccess("");

    if (password.length < 6) {
      setError("パスワードは6文字以上にしてください");
      return;
    }

    try {
      const response = await axios.post("https://api.glainews.com/api/register", { email, password });
      if (response.status === 201) {
        setSuccess("アカウント登録に成功しました！");
        setTimeout(() => navigate("/login"), 2000); // 2秒後にログインページへ
      }
    } catch (err) {
      setError(err.response?.data?.error || "登録に失敗しました");
    }
  };

  return (
    <Container sx={{ py: 4, maxWidth: 400 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        新規登録
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}

      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
        <TextField
          fullWidth
          label="メールアドレス"
          variant="outlined"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="パスワード"
          variant="outlined"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          sx={{ mb: 2 }}
        />
        <Button fullWidth variant="contained" color="primary" type="submit">
          登録する
        </Button>
      </Box>
    </Container>
  );
};

export default Signup;